import React, { FC, ReactNode } from 'react'
import { useLogin } from '../../providers/LoginProvider'
import { isCommentator, isModerator, isOperator } from '../../utils/user'
import { Typography } from '@mui/material'

type RoleGuardProps = {
  children: ReactNode
  allowedRoles: Array<'moderator' | 'operator' | 'commentator'>
}

export const RoleGuard: FC<RoleGuardProps> = ({ children, allowedRoles }) => {
  const { user } = useLogin()

  if (!user.loggedIn) {
    return null
  }

  const hasAccess = allowedRoles.some(role => {
    switch (role) {
      case 'moderator':
        return isModerator(user)
      case 'operator':
        return isOperator(user)
      case 'commentator':
        return isCommentator(user)
      default:
        return false
    }
  })

  if (!hasAccess) {
    return (
      <Typography sx={{ maxWidth: 600 }}>
        You don&apos;t have access rights to the new Comments Admin. Please contact Cecilia Wikman
        or{' '}
        <a href="https://chat.google.com/room/AAAAI38keo0?cls=7" target="_blank" rel="noreferrer">
          Yle Comments support channel
        </a>
        .
      </Typography>
    )
  }

  return <>{children}</>
}
